import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles((theme) => ({
  button: {
    color: theme.palette.components.icon,
  },
}))

export default styles
